module.exports = __webpack_public_path__ + "img/heart.4633733d.svg";